import { useEffect, useRef, useState } from "react";
import API from '@api/api'
import { Spin, message } from "antd";
import styles from './index.module.scss'
import eventBus from "@utils/eventBus";
import QRCode from 'qrcode.react'

const formatAmount = (amount) => {
    // 使用正则表达式匹配非零小数
    return amount >= 1 ? parseFloat(amount) : amount
}

const Tips = () => {
    return (
        <ul className={styles.Tips}>
            <li>支付完成后默认您同意<a target='_blank' href={`/master会员条款.htm?t=${new Date().getTime()}`}>相关协议条例</a> </li>
            <li>虚拟商品，支付后无法退还</li>
        </ul>
    )
}

const AlipayQrcode = (props) => {
    const alipayFrameRef = useRef()

    useEffect(() => {
        alipayFrameRef.current.contentWindow.document.write(props.url)
    }, [])

    return (
        <div className={styles.PayContent}>
            <div className={styles.iframePlaceholderWrap}>
                <Spin wrapperClassName={styles.iframePlaceholderSpin} spinning>
                    <div className={`${styles.iframePlaceholder} ${styles.alipay}`}></div>
                </Spin>
            </div>
            <iframe ref={alipayFrameRef}
                className={styles.payFrame}
                style={{ display: 'block' }}
                // srcDoc={payUrl}
                width="200"
                height="200"
                marginWidth={0}
                marginHeight={0}
                frameBorder="0"
                border="0"
                scrolling="no"
            ></iframe>
        </div>
    )
}

const WechatQrcode = (props) => {
    // weixin://wxpay/bizpayurl?pr=aYnckdQz3
    return (
        <div className={styles.PayContent}>
            <QRCode
                id="qrcode"
                value={props.url}
                size={200}
                level="H"
                style={{margin: 'auto'}}
                imageSettings={{
                    src: require('@assets/images/icon_wxpay@2x.png'),
                    width: 50,
                    height: 50,
                    excavate: true,
                }}
            />
        </div>
    )
}

export default function Payment (props) {
    const isMounted = useRef(true)
    const [tradeId] = useState(props.tradeId)
    const [loading, setLoading] = useState(false)
    const [powerAmount, setPowerAmount] = useState(0) // 虹豆数
    const [isPowerPackage, setIsPowerPackage] = useState(false) // 加油包
    const [isDiyPower, setIsDiyPower] = useState(false)

    const {channel, dealAmount, payUrl} = props

    useEffect(() => {
        return () => isMounted.current = false
    }, [])

    const checkTradeStatus = () => {
        API.paymentOrderStatus2({
            tradeId: tradeId
        }).then(res => {
            if (res.code != 0) return
            const item = res.data
            if (item.status == 'success') {
                console.log('订单支付成功', item.tradeId)
                message.success('支付成功')
                eventBus.emit('updatePower')
                eventBus.emit('updateUserInfo')
                props.onClose()
                return
            } else if (item.status == 'closed') {
                console.log('订单关闭，刷新订单', item.tradeId)
                message.success('订单已关闭')
                props.onClose()
                return
            } else {
                setTimeout(() => {
                    console.log(isMounted.current)
                    if (isMounted.current) checkTradeStatus()
                }, 400)
            }
        })
    }

    useEffect(() => {
        checkTradeStatus()
    }, [])

    return (
        <div className={styles.Container}>
            <div className={styles.Head}>
            {
                <span>{props.title || "充值"}</span>
            }
            </div>
            <Spin spinning={loading}>
            <div className={styles.Content}>
                <div className={styles.Channel}>
                { channel == 'alipay' && <span><img src={require('@assets/images/icon_alipay.png')} />支付宝扫码支付</span>}
                { channel == 'wechat' && <span><img src={require('@assets/images/icon_wxpay.png')} />微信扫码支付</span>}
                </div>
                <div className={styles.Qrcode}>
                {
                    payUrl &&
                    <>
                    { channel == 'alipay' && <AlipayQrcode url={payUrl} /> }
                    { channel == 'wechat' && <WechatQrcode url={payUrl} /> }
                    </>
                }
                </div>
                <div className={styles.PayPrice}>
                {
                    dealAmount && 
                    <>
                    <span>扫码支付：</span>
                    <span>￥</span>
                    <span>{formatAmount(dealAmount)}</span>
                    </>
                }
                </div>
                {
                    props.extraRender && 
                    <div className={styles.ExtraContent}>
                    {props.extraRender}
                    </div>
                }
                <Tips/>
            </div>
            </Spin>
        </div>
    )
}